import { CaseCategoriesModel } from '@models/case-categories.model';
import { crudActions, DatasetTableConfig, TableConfigBuilder, textColumn } from '@ui/lib/ui-kit/ui-dataset-table';

type Category = CaseCategoriesModel.CategoryWithStringRetention;

/**
 * The Database → Categories table, column for column
 * (`pages/database/pages/categories/categories-table.util.ts`).
 *
 * Two deliberate differences: `retentionPeriod` arrives already translated, and
 * there is no `defaultRowAction` — the page makes the whole row an Edit target,
 * which would give this panel two ways to open the same dialog.
 */
export function createCaseManagerCategoryResultTableConfig(): DatasetTableConfig<Category> {
  return new TableConfigBuilder<Category>()
    .columns([
      textColumn<Category>('name', 'CASE_CATEGORIES.TABLE.NAME', {
        width: 'minmax(150px, 1fr)',
        mobileVisible: true,
      }),
      textColumn<Category>('retentionPeriod', 'CASE_CATEGORIES.TABLE.PERIOD', {
        width: 'minmax(150px, 1fr)',
        mobileVisible: true,
      }),
    ])
    .actions(crudActions<Category>())
    .trackBy('_id')
    .rowHeight(52)
    .build();
}
